/**
 * Automatically refresh website token after 1 hour
 */
setInterval(function() {
    $.get('refresh-csrf').done(function (data) {
        $('head meta[name="csrf-token"]').attr('content', data);
    });
}, 3600000);

/* Popover */
$('[data-toggle="popover"]').popover();

/* */
$('.form-control').on('focus', function () {
    if ($(this).hasClass('is-invalid')) {
        $(this).removeClass('is-invalid');
        $(this).parents('.input-outlined').find('.invalid-feedback').hide();
    }
});

